import d3 from 'd3';
import {
  Measure
} from '../common/measure';

class TreeController {
  constructor(
    $scope,
    $element,
    rx,
    TreeService,
    LayoutService,
    CurrentModelService,
    RouterService,
    $rootScope,
  ) {
    this.$element = $element;
    this.LayoutService = LayoutService;
    this.TreeService = TreeService;
    this.renderDebounce = 100;
    this.CurrentModelService = CurrentModelService;
    this.router = RouterService;
    this.$rootScope = $rootScope;
    const subscriptions = [
      rx.Observable.merge(
        rx.Observable.merge(
          $scope.$eventToObservable('dashboardResize'),
          $scope.$eventToObservable('resize'),
          $scope.$eventToObservable('splitter1Changed'),
          $scope.$toObservable('$ctrl.aggregate'),
        ).debounce(this.renderDebounce),
        $scope.$eventToObservable('resizeBeforePrint'),
        $scope.$eventToObservable('afterPrint'),
        $scope.$eventToObservable('init'),
      ).map(e => {
        if (e.name === 'resizeBeforePrint' ||
          (this.router.pdf && this.router.CurrentFilterService.filter.isDashboard)) this.needCalcHeight = true;
        else this.needCalcHeight = false;
      }).subscribe(() => this.render()),
    ];

    $scope.$on('$destroy', () => subscriptions.forEach((subscription) =>
      subscription.dispose()));
  }

  render() {
    const fontColor = this.$rootScope.theme == 'dark' ? '#eee' : 'black';
    const backgroundColor = this.$rootScope.theme == 'dark' ?  '#222222' : 'auto';
    console.log(this.fontColor);

    const aggregate = this.aggregate;

    //console.log("TREE", aggregate);

    this.$element.find('svg').remove();

    if (!aggregate || !this.aggregate.filter) {
      return;
    }

    const animate = !this.LayoutService.isPrint && !this.router.pdf;
    const profileChart = this.$element[0];
    // const root = this.getRoot(aggregate, this.aggregate.filter);
    const root = this.TreeService.getRoot(this.model, aggregate);

    const width = this.$element.width();
    const height = this.needCalcHeight ? (this.TreeService.getRowsQuantity(root) *
      this.TreeService.oneRow) : this.$element.height();

    root.x0 = height / 2;
    root.y0 = 0;

    const margin = {
      'left': 100,
      'top': 0
    };

    let i = 0;
    const duration = 750;

    const tree = d3.layout.tree()
      .size([height, width]);

    const diagonal = d3.svg.diagonal()
      .projection(function(d) {
        return [d.y, d.x];
      });

    const svg = d3.select(profileChart).append('svg')
      .attr('width', width)
      .attr('height', height)
      .append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    //d3.select(self.frameElement).style("height", "800px");

    const update = (source) => {

      // Compute the new tree layout.
      const nodes = tree.nodes(root).reverse();
      const links = tree.links(nodes);

      // Normalize for fixed-depth.
      nodes.forEach(d => {
        d.y = d.depth * 180;
      });

      // Update the nodes…
      const node = svg.selectAll('g.node')
        .data(nodes, d => d.id || (d.id = ++i));

      if (animate) {
        // Enter any new nodes at the parent's previous position.
        const nodeEnter = node.enter().append('g')
          .attr('class', 'node')
          .attr(
            'transform',
            d => 'translate(' + source.y0 + ',' + source.x0 + ')',
          )
          .on('click', click);

        nodeEnter.append('circle')
          .attr('r', 1e-6)
          .style('fill', d => d._children ? 'lightsteelblue' : '#fff');

        nodeEnter.append('text')
          .attr('x', function(d) {
            return d.children || d._children ? -10 : 10;
          })
          .attr('dy', '.35em')
          .attr('text-anchor', d => d.children || d._children ? 'end' : 'start')
          .text(d => d.name)
          // .style('fill', fontColor)
          .style('fill-opacity', 1e-6);

        // Transition nodes to their new position.
        const nodeUpdate = node.transition()
          .duration(duration)
          .attr('transform', d => 'translate(' + d.y + ',' + d.x + ')');

        nodeUpdate.select('circle')
          .attr('r', 4.5)
          .style('fill', d => d._children ? 'lightsteelblue' : backgroundColor);

        nodeUpdate.select('text')
          .style('fill', fontColor)
          .style('fill-opacity', 1);

        // Transition exiting nodes to the parent's new position.
        const nodeExit = node.exit().transition()
          .duration(duration)
          .attr(
            'transform',
            d => 'translate(' + source.y + ',' + source.x + ')',
          )
          .remove();

        nodeExit.select('circle')
          .attr('r', 1e-6);

        nodeExit.select('text')
          .style('fill', fontColor)
          .style('fill-opacity', 1e-6);
      } else {
        // Enter any new nodes at the parent's previous position.
        const nodeEnter = node.enter().append('g')
          .attr('class', 'node')
          .attr('transform', d => 'translate(' + d.y + ',' + d.x + ')')
          .on('click', click);

        nodeEnter.append('circle')
          .attr('r', 4.5)
          .style('fill', d => d._children ? 'lightsteelblue' : '#fff');

        nodeEnter.append('text')
          .attr('x', d => d.children || d._children ? -10 : 10)
          .attr('dy', '.35em')
          .attr('text-anchor', d => d.children || d._children ? 'end' : 'start')
          .text(d => d.name)
          .style('fill-opacity', 1);
      }

      // Update the links…
      const link = svg.selectAll('path.node-link')
        .data(links, d => d.target.id);

      if (animate) {
        // Enter any new links at the parent's previous position.
        link.enter().insert('path', 'g')
          // .attr('class', 'node-link')
          .attr('style', 'fill: none; stroke: #ccc; stroke-width: 1.5px;')
          .attr('d', d => {
            const o = {
              x: source.x0,
              y: source.y0
            };
            return diagonal({
              source: o,
              target: o
            });
          });

        // Transition links to their new position.
        link.transition()
          .duration(duration)
          .attr('d', diagonal);

        // Transition exiting nodes to the parent's new position.
        link.exit().transition()
          .duration(duration)
          .attr('d', d => {
            const o = {
              x: source.x,
              y: source.y
            };
            return diagonal({
              source: o,
              target: o
            });
          })
          .remove();
      } else {
        // Enter any new links at the parent's previous position.
        link.enter().insert('path', 'g')
          .attr('class', 'node-link')
          .attr('d', d => diagonal({
            source: {
              x: d.source.x,
              y: d.source.y
            },
            target: {
              x: d.target.x,
              y: d.target.y
            },
          }));
      }

      // Stash the old positions for transition.
      nodes.forEach(d => {
        d.x0 = d.x;
        d.y0 = d.y;
      });
    };

    function updateFast(source) {

      // Compute the new tree layout.
      const nodes = tree.nodes(root).reverse();
      const links = tree.links(nodes);

      // Normalize for fixed-depth.
      nodes.forEach(d => {
        d.y = d.depth * 180;
        // d.y = d.depth * 360;
      });

      // Update the nodes…
      const node = svg.selectAll('g.node')
        .data(nodes, d => d.id || (d.id = ++i));
      // Enter any new nodes at the parent's previous position.
      const nodeEnter = node.enter().append('g')
        .attr('class', 'node')
        .attr('transform', d => 'translate(' + d.y + ',' + d.x + ')')
        .on('click', click);

      nodeEnter.append('circle')
        .attr('r', 4.5)
        .style('fill', d => d._children ? 'lightsteelblue' : '#fff');

      nodeEnter.append('text')
        .attr('x', d => d.children || d._children ? -10 : 10)
        .attr('dy', '.35em')
        .attr('text-anchor', d => d.children || d._children ? 'end' : 'start')
        .text(d => d.name)
        .style('fill-opacity', 1);

      // Update the links…
      const link = svg.selectAll('path.node-link')
        .data(links, d => d.target.id);

      // Enter any new links at the parent's previous position.
      link.enter().insert('path', 'g')
        .attr('class', 'node-link')
        .attr('d', d => {
          return diagonal({
            source: {
              x: d.source.x,
              y: d.source.y
            },
            target: {
              x: d.target.x,
              y: d.target.y
            },
          });
        });
    }

    const drilldown = (drill, cell) => {
      let neddDelete = !drill;
      const cuts = [];
      for (let i = 0; i < this.aggregate.filter.drilldown.length; ++i) {
        const drilldown = this.aggregate.filter.drilldown[i];

        const cut = cell ? this.CurrentModelService.model.getCellFilter(drilldown, cell) :
          this.router.CurrentFilterService.filter.filters.find(fCut => fCut.dimension === drilldown);
        if (neddDelete) window.removeCut(cut);
        else cuts.push(cut);
        if (drill === drilldown) {
          neddDelete = true;
        }
      }
      this.router.drilldownCuts(cuts);
    };

    // Toggle children on click.
    function click(d) {
      drilldown(d.dd, d.cell);
    }


    update(root);
  }
}

export const TreeComponent = {
  template: '',
  bindings: {
    model: '<',
    aggregate: '<',
  },
  controller: TreeController,
};



// WEBPACK FOOTER //
// ./src/stat/tree.component.js